import type { AnyRoute } from '../route.ts'
import type { Authorization } from '../types/authorization.ts'

export const authorizedRoutes =
  (authorization: Authorization) => (route: AnyRoute) =>
    route.isAuthorized(authorization)
